export interface ChatTurnLayout {
	/** Indexes of the items that open a turn on the avatar's side: the first such item after one from the other side, or at index 0. */
	starts: ReadonlySet<number>;
	/** The start of the turn the latest item belongs to; null while the latest item is from the other side. */
	newestStart: number | null;
}

/** Where each avatar-side turn starts in a flat message list, and which turn is the newest. */
export const layoutChatTurns = <T>(items: readonly T[], isAvatarSide: (item: T) => boolean): ChatTurnLayout => {
	const starts = new Set<number>();
	items.forEach((item, index) => {
		if (isAvatarSide(item) && (index === 0 || !isAvatarSide(items[index - 1]))) starts.add(index);
	});
	const latest = items.at(-1);
	return { starts, newestStart: latest !== undefined && isAvatarSide(latest) ? Math.max(...starts) : null };
};
